(function(){
  function killPackHover(){
    var packs = document.querySelectorAll('section.petal-page button.petal-pack');
    for(var i=0;i<packs.length;i++){
      packs[i].style.setProperty('transition','none','important');
      packs[i].style.setProperty('-webkit-tap-highlight-color','transparent');
      packs[i].style.setProperty('outline','none');
    }
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){ killPackHover(); setTimeout(killPackHover,300); });
  } else {
    killPackHover(); setTimeout(killPackHover,300);
  }
  window.addEventListener('load',function(){ setTimeout(killPackHover,500); });
})();

/* Bundle product links — clicking a product's title or image inside an
   ALREADY-selected pack opens that product's page in a new tab.
   Capture phase so the is-selected check runs BEFORE the pack-select
   handler flips the class: first click selects the pack, second click
   on the title/image navigates. */
(function(){
  document.addEventListener('click', function(e){
    if(!e.target || !e.target.closest) return;
    var prod = e.target.closest('.petal-bundle-product[data-product-url]');
    if(!prod) return;
    var hit = e.target.closest('strong, img');
    if(!hit || !prod.contains(hit)) return;
    var pack = prod.closest('.petal-pack');
    if(!pack || !pack.classList.contains('is-selected')) return;
    e.preventDefault();
    var url = prod.getAttribute('data-product-url');
    if(url) window.open(url, '_blank', 'noopener');
  }, true);
})();
